import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Select,
  Checkbox,
  DatePicker,
  Message,
  Card,
  Table,
  Switch,
  Pagination,
} from '@alifd/next';
import client from '@/lib/feathers';
import 'antd/dist/antd.css';
import ReactDragListView from 'react-drag-listview'; // 拖曳功能
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import { Modal, Image, message, Upload } from 'antd'; // dialog UI
import { pdfjs, Page } from 'react-pdf';
import ezconImg from '../../../public/ezcon.png';
import styles from './index.module.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const { Item } = Form;
const { RangePicker } = DatePicker;
const GlobalTempalate = (props) => {
  const Document = React.lazy(() => {
    return import('react-pdf').then((module) => ({ default: module.Document }));
  });
  const FileViewer = React.lazy(() => {
    return import('react-file-viewer');
  });
  // residentAccountNumbers 戶號Table
  const residentAccountNumbers = client.service('residentAccountNumbers');
  // categoryMenu 全域公告類別Table
  const categoryMenu = client.service('categoryMenu');
  // announcement 公告Table
  const announcement = client.service(props.data.service);
  // 公播列表
  const broadcast = client.service('broadcast');
  // 公播盒列表
  const broadcastBox = client.service('broadcastBoxs');
  const [announcementArr, setAnnouncementArr] = useState([]);
  const [categoryArr, setCategoryArr] = useState([]);
  const [categoryDataArr, setCategoryDataArr] = useState([]);
  const [addAnnouncementDialog, setAnnouncementDialog] = useState(false);
  const [addNotImgDialog, setAddNotImgDialog] = useState(false);
  const [categoryDialog, setCategoryDialog] = useState(false);
  const [editAnnouncementDialog, setEditAnnouncementDialog] = useState(false);
  const [editNotImgDialog, setEditNotImgDialog] = useState(false);
  const [editCategoryDialog, setEditCategoryDialog] = useState(false);
  const [searchDialog, setSearchDialog] = useState(false);
  const [editAnnouncementIndex, setEditAnnouncementIndex] = useState('');
  const [editCategoryIndex, setEditCategoryIndex] = useState('');
  const [titleText, setTitleText] = useState('');
  const [contentText, setContentText] = useState('');
  const [category, setCategory] = useState('');
  const [announcementTime, setAnnouncementTime] = useState(moment());
  const [allows, setAllows] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [addCategory, setAddCategory] = useState('');
  const [checkedStatus, setCheckedStatus] = useState(false);
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [messageStatus, setMessageStatus] = useState(false);
  const [userName, setUserName] = useState('');
  const currentDate = moment();
  const currentDate1 = moment().subtract(1, 'days');

  // 上傳圖片
  const [parsed, setParsed] = useState([]);
  const [parsed64, setParsed64] = useState([]); // Base64
  const [file, setFile] = useState([]);
  const uploadFile = useRef(null);

  //  上傳其他格式黨案
  const [otherFile, setOtherFile] = useState([]);
  const uploadOtherFile = useRef(null);
  const [keepFileStatus, setKeepFileStatus] = useState(false);

  // 搜尋
  const [serachCategory, setSerachCategory] = useState('');
  const [serachKey, setSerachKey] = useState('');
  const [serachStartDate, setSerachStartDate] = useState('');
  const [serachEndDate, setSerachEndDate] = useState('');

  // sort
  const [curdataIndex, setcurDataIndex] = useState('createdTime');
  const [curorder, setcurOrder] = useState('asc');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = announcementArr.slice(indexOfFirstPost, indexOfLastPost);

  // preview
  const [previewSingleDialog, setPreviewSingleDialog] = useState(false);
  const [fileType, setFileType] = useState('');
  const [fileViewerType, setFileViewerType] = useState('');
  const [fileViewerPath, setFileViewerPath] = useState('');
  const [fileViewerKey, setFileViewerKey] = useState('');
  const [fileViewerStatus, setFileViewerStatus] = useState(false);
  const [numPages, setNumPages] = useState(null);

  // 公播
  const [broadcastData, setBroadcastData] = useState([]);
  const [broadcastStatus, setBroadcastStatus] = useState(false);
  const [broadcastGroupId, setBroadcastGroupId] = useState('');

  // 圖片多檔上傳
  const [fileList, setFileList] = useState([]);
  useEffect(() => {
    try {
      residentAccountNumbers.find({}).then((res) => {
        setResidentAccountNumbersArr(res.data);
      });
      client.reAuthenticate().then((data) => {
        setUserName(data.user.name);
      });
      broadcast
        .find({ query: { broadcastGroup: { $exists: true } } })
        .then((res) => {
          console.log(res.data);
          setBroadcastData(res.data);
        });
    } catch (error) {
      console.log('未連接server:err', error);
    }
  }, []);

  // announcement
  async function funFind(para) {
    const result = await announcement.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funUpdate(id, obj) {
    return await announcement.patch(id, obj);
  }
  async function funRemove(id) {
    return await announcement.remove(id);
  }

  const serverDataUpdate = useCallback(
    (dataIndex, order) => {
      const rdataIndex = dataIndex || curdataIndex;
      const rorder = order || curorder;

      funFind({}).then((result) => {
        setAnnouncementArr(
          result.sort((a, b) => {
            const result = (typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
            ).localeCompare(
              typeof b[rdataIndex] === 'number'
                ? b[rdataIndex].toString()
                : b[rdataIndex]
            );
            return (rorder === 'asc') === result > 0 ? 1 : -1;
          })
        );
      });
    },
    [curdataIndex, curorder, funFind]
  );
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverDataUpdate(dataIndex, order);
  };

  useEffect(() => {
    serverDataUpdate();
  }, []);

  // categoryMenu
  async function findCategory() {
    const result = await categoryMenu.find({
      query: { service: props.data.service },
    });
    return result && result.data ? result.data : [];
  }
  async function updateCategory(id, obj) {
    return await categoryMenu.patch(id, obj);
  }
  function serverCategoryDataUpdate() {
    findCategory()
      .then((res) => {
        console.log('==categoryMenu find success:', res);
        setCategoryArr(res);
        setCategoryDataArr(res[0].data);
      })
      .catch((error) => {
        console.log('==categoryMenu find fail:', error);
      });
  }
  useEffect(() => {
    serverCategoryDataUpdate();
  }, []);

  // 類別拖曳Function
  const onDragCategoryEnd = (fromIndex, toIndex) => {
    if (toIndex < 0) return; // Ignores if outside designated area

    const items = categoryArr[0]; // 所有類別資料
    const item = items.data.splice(fromIndex, 1)[0];
    items.data.splice(toIndex, 0, item); // 把刪除的新增到移動的位置

    updateCategory(items._id, items)
      .then((res) => {
        console.log('==categoryMenu drag categoryName success:', res);
        serverCategoryDataUpdate();
        Message.success('拖曳成功');
      })
      .catch((error) => {
        console.log('==categoryMenu drag categoryName fail:', error);
        Message.error(`${error}`);
      });
  };

  // 上傳圖片大小
  function beforeImgUpload() {
    return new Promise((resolve, reject) => {
      (async () => {
        if (uploadFile.current.files.length > 0) {
          const isLt20M =
            (await uploadFile.current.files[0].size) / 1024 / 1024 < 20;

          if (!isLt20M) {
            Message.error('Image must smaller than 20MB!');
            return reject();
          }
          resolve(isLt20M);
        } else {
          setParsed64('');
        }
      })();
    });
  }

  // 上傳其他格式大小
  function beforeOtherUpload() {
    return new Promise((resolve, reject) => {
      (async () => {
        if (uploadOtherFile.current.files.length > 0) {
          const isLt50M =
            (await uploadOtherFile.current.files[0].size) / 1024 / 1024 < 50;

          if (!isLt50M) {
            Message.error('file must smaller than 50MB!');
            return reject();
          }
          resolve(isLt50M);
        }
      })();
    });
  }

  // 上傳圖片onChange
  const handleFiles = async () => {
    try {
      await beforeImgUpload();
      const files = [...parsed];
      const data = await uploadFile.current.files[0];
      console.log(data);
      files.push(data);
      setParsed(files);

      // 轉Base64 上傳檔案後呈現沒有寫到DB
      const reader = new FileReader();
      reader.onload = function () {
        const dataURL = reader.result;
        setParsed64(dataURL);
      };
      reader.readAsDataURL(data);
    } catch (err) {
      console.log(err);
    }
  };

  // 上傳其他格式onChange
  const handleOtherFiles = async () => {
    try {
      await beforeOtherUpload();
      if (uploadOtherFile.current.files.length > 0) {
        setOtherFile([...otherFile, uploadOtherFile.current.files[0]]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  function deleteFile(name) {
    const updatedParsed = [...otherFile].filter((item) => item.name !== name);
    setOtherFile(updatedParsed);
  }

  // 推播棟別
  function allowsCheckBox() {
    const dataSource = [];

    for (let i = 0; i < residentAccountNumbersArr.length; i++) {
      // 第一層
      const building = residentAccountNumbersArr[i].building;
      // let householdNumber = residentAccountNumbersArr[i].householdNumber;
      let obj = dataSource.find((item) => item.label === building);
      if (!obj) {
        obj = {
          value: `${building}`,
          label: `${building}`,
        };
        dataSource.push(obj);
      }
    }

    return dataSource;
  }

  const disabledDate = (date, view) => {
    switch (view) {
      case 'date':
        return date.valueOf() <= currentDate1.valueOf();
      case 'year':
        return date.year() < currentDate.year();
      case 'month':
        return (
          date.year() * 100 + date.month() <
          currentDate.year() * 100 + currentDate.month()
        );
      default:
        return false;
    }
  };
  const onError = (e) => {
    console.log(e, 'error in file-viewer');
  };
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function previewTypeStyles(category) {
    if (category === '社區規約') {
      const result = styles.color1;
      return result;
    } else if (category === '一般公告') {
      const result = styles.color2;
      return result;
    } else if (category === '社區活動') {
      const result = styles.color3;
      return result;
    } else if (category === '會議記錄') {
      const result = styles.color4;
      return result;
    } else if (category === '財務狀況') {
      const result = styles.color5;
      return result;
    } else if (category === '維修保養') {
      const result = styles.color6;
      return result;
    } else if (category === '系統') {
      const result = styles.color7;
      return result;
    } else if (category === '檔案') {
      const result = styles.color8;
      return result;
    } else {
      const result = styles.color9;
      return result;
    }
  }

  const uploadFiles = (file) => {
    const formData = new FormData();
    formData.append('files', file);
    const res = axios.post(
      '/newUploads?type=announcement&createCompressImage=true',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    return res;
  };

  const deleteUploadFile = (file) => {
    console.log({ delete: file });
    return client.service('uploads').remove(file.response._id);
  };
  console.log(fileList);

  return (
    <>
      {/* 查詢公告 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={searchDialog}
        onOk={() => {
          if (
            !serachCategory &&
            !serachKey &&
            !serachStartDate &&
            !serachEndDate
          ) {
            Message.warning('至少選擇一種(以上)方式搜尋');
          }

          if (serachCategory && serachKey && serachStartDate && serachEndDate) {
            const serach = announcementArr.filter(
              (x) =>
                x.title.match(
                  serachKey.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
                ) &&
                x.type === serachCategory &&
                moment(x.announcementTime).isBetween(
                  serachStartDate,
                  serachEndDate
                )
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          } else if (serachCategory && serachKey) {
            const serach = announcementArr.filter(
              (x) =>
                x.title.match(
                  serachKey.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
                ) && x.type === serachCategory
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          } else if (serachCategory && serachStartDate && serachEndDate) {
            const serach = announcementArr.filter(
              (x) =>
                x.type === serachCategory &&
                moment(x.announcementTime).isBetween(
                  serachStartDate,
                  serachEndDate
                )
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          } else if (serachKey && serachStartDate && serachEndDate) {
            const serach = announcementArr.filter(
              (x) =>
                x.title.match(
                  serachKey.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
                ) &&
                moment(x.announcementTime).isBetween(
                  serachStartDate,
                  serachEndDate
                )
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          } else if (serachCategory) {
            const serach = announcementArr.filter(
              (x) => x.type === serachCategory
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          } else if (serachKey) {
            const serach = announcementArr.filter((x) =>
              x.title.match(
                serachKey.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\@\.]/g, '')
              )
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          } else if (serachStartDate && serachEndDate) {
            const serach = announcementArr.filter((x) =>
              moment(x.announcementTime).isBetween(
                serachStartDate,
                serachEndDate
              )
            );
            setAnnouncementArr(serach);
            setSearchDialog(false);
          }
          setSerachCategory('');
          setSerachKey('');
          setSerachStartDate('');
          setSerachEndDate('');
        }}
        onCancel={() => {
          setSearchDialog(false);
        }}
        onClose={() => {
          setSearchDialog(false);
        }}
      >
        <Form>
          <h2>{`${props.data.name}搜尋`}</h2>
          <Item label="類別">
            <Select
              hasClear
              placeholder="請選擇類別"
              dataSource={categoryDataArr}
              onChange={(value) => {
                setSerachCategory(value);
              }}
            />
          </Item>
          <Item label={`關鍵字(${props.data.name}標題搜尋)`}>
            <Input
              name="keyWord"
              placeholder="請輸入關鍵字"
              onChange={(value) => {
                setSerachKey(value);
              }}
            />
          </Item>
          <Item label={`${props.data.name}時間`}>
            <RangePicker
              onChange={(value) => {
                setSerachStartDate(
                  moment(value[0]).subtract(1, 'days').format('YYYY-MM-DD')
                );
                setSerachEndDate(
                  moment(value[1]).add(1, 'days').format('YYYY-MM-DD')
                );
              }}
            />
          </Item>
        </Form>
      </Dialog>

      {/* 公告類別 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={categoryDialog}
        onOk={() => {
          setCategoryDialog(false);
        }}
        onCancel={() => {
          setCategoryDialog(false);
        }}
        onClose={() => {
          setCategoryDialog(false);
        }}
      >
        <Form>
          <Item label="新增類別">
            <Input
              value={addCategory}
              name="addCategory"
              placeholder="請輸入類別名稱"
              onChange={(value) => {
                setAddCategory(value);
              }}
            />
            <Button
              className={styles.addCategoryBtn}
              type="primary"
              onClick={() => {
                if (!addCategory) {
                  Message.warning('請輸入類別');
                } else {
                  const item = categoryArr[0];
                  updateCategory(item._id, {
                    $addToSet: { data: { $each: [addCategory] } },
                  })
                    .then((res) => {
                      console.log(
                        '==categoryMenu add categoryName success:',
                        res
                      );
                      serverCategoryDataUpdate();
                      setAddCategory('');
                      Message.success('新增成功');
                    })
                    .catch((error) => {
                      console.log(
                        '==categoryMenu add categoryName fail:',
                        error
                      );
                      Message.error(`${error}`);
                    });
                }
              }}
            >
              新增
            </Button>
            <p>可拖曳表格欄位變換類別順序</p>
            <ReactDragListView onDragEnd={onDragCategoryEnd}>
              <Table dataSource={categoryDataArr}>
                <Table.Column
                  title="類別"
                  width={100}
                  cell={(_value, index) => {
                    return <>{categoryDataArr[index]}</>;
                  }}
                />
                <Table.Column
                  title="操作"
                  width={200}
                  lock="right"
                  cell={(_value, index, record) => {
                    return (
                      <div className={styles.categoryBtn}>
                        <Button
                          type="normal"
                          onClick={() => {
                            setCategoryName(categoryDataArr[index]);
                            setEditCategoryIndex(index);

                            setEditCategoryDialog(true);
                          }}
                        >
                          編輯
                        </Button>

                        <Button
                          type="primary"
                          warning
                          onClick={() => {
                            const item = categoryArr[0];
                            Swal.fire({
                              title: `確定刪除此類別(${record})?`,
                              text: '刪除後將無法復原!!',
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#BEBEBE',
                              confirmButtonText: '確定',
                              cancelButtonText: '取消',
                            }).then((result) => {
                              if (result.isConfirmed) {
                                Swal.fire('刪除!', '此類別已刪除', 'success');
                                updateCategory(item._id, {
                                  $pull: { data: record },
                                })
                                  .then((res) => {
                                    console.log(
                                      '==categoryMenu delete categoryName success:',
                                      res
                                    );
                                    serverCategoryDataUpdate();
                                    Message.success('刪除成功');
                                  })
                                  .catch((error) => {
                                    console.log(
                                      '==categoryMenu delete categoryName fail:',
                                      error
                                    );
                                    Message.error(`${error}`);
                                  });
                              }
                            });
                          }}
                        >
                          刪除
                        </Button>
                      </div>
                    );
                  }}
                />
              </Table>
            </ReactDragListView>
          </Item>
        </Form>
      </Dialog>

      {/* 編輯類別 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editCategoryDialog}
        onOk={() => {
          const item = categoryArr[0];
          item.data[editCategoryIndex] = categoryName;
          updateCategory(item._id, item)
            .then((res) => {
              console.log('==categoryMenu update categoryName success:', res);
              serverCategoryDataUpdate();
              setEditCategoryDialog(false);
              Message.success('更新成功');
            })
            .catch((error) => {
              console.log('==categoryMenu update categoryName fail:', error);
              Message.error(`${error}`);
            });
        }}
        onCancel={() => {
          setEditCategoryDialog(false);
        }}
        onClose={() => {
          setEditCategoryDialog(false);
        }}
      >
        <Form>
          <Item label="編輯類別名稱">
            <Input
              value={categoryName}
              name="categoryName"
              placeholder="請輸入類別名稱"
              onChange={(value) => {
                setCategoryName(value);
              }}
            />
          </Item>
        </Form>
      </Dialog>

      {/* 新增公告  圖片類型 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addAnnouncementDialog}
        onOk={() => {
          Swal.fire({
            title: `確定新增標題(${titleText})${props.data.name}?`,
            text: '請確認資料填寫完整!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then(async (result) => {
            if (result.isConfirmed) {
              let announcementNewArr = '';
              Swal.fire('成功!', `此${props.data.name}已新增`, 'success');
              const newObject = {
                createdTime: moment().valueOf(),
                updatedTime: moment().valueOf(),
                order: announcementArr.length,
                announcer: userName,
                announcementTime: announcementTime.valueOf(),
                type: category,
                title: titleText,
                titleText: contentText,
                fileType: 'img',
                allows,
                files: fileList,
                broadcastStatus,
                broadcastGroupId,
                checkedStatus,
              };
              await announcement
                .create(newObject)
                .then((res) => {
                  console.log(res);
                  serverDataUpdate();
                  setParsed64('');
                  setAllows([]);
                  setMessageStatus(false);
                  setAnnouncementDialog(false);
                  setFileList([]);
                  setCheckedStatus(false);
                  announcementNewArr = res;
                })
                .catch((error) => {
                  console.log('==announcement create fail:', error);
                });

              // 新增至公播清單中
              if (broadcastStatus && broadcastGroupId) {
                let newBroadcastData = '';
                const newChildren = [];
                for (let i = 0; i < announcementNewArr.files.length; i++) {
                  newChildren.push({
                    typeContent: 'image',
                    typeFormat: announcementNewArr.files[i].path,
                    textSize: 'originalSize',
                    textTags: '',
                    textColor: '',
                    textLevel: 'center',
                    textVertical: 'center',
                    unit: 's',
                    seconds: 10,
                  });
                }
                console.log('newChildren:', newChildren);

                const newBroadcast = {
                  title: titleText,
                  backgroundMusic: null,
                  userName,
                  template: 'one',
                  announcementId: announcementNewArr._id,
                  content: [
                    {
                      carousel: true,
                      color: '#FFFFFF',
                      size: 100,
                      children: [...newChildren],
                    },
                  ],
                };
                console.log('==newBroadcast:', newBroadcast);
                await broadcast.create(newBroadcast).then((res) => {
                  newBroadcastData = res;
                  Message.success('新增至公播清單中');
                  console.log(res);
                });

                // 更新公播群組
                await broadcast
                  .find({ query: { _id: broadcastGroupId } })
                  .then((res) => {
                    const newBroadcastGroup = res.data[0];
                    newBroadcastGroup.broadcastGroupId.push(
                      newBroadcastData._id
                    );
                    newBroadcastGroup.broadcastGroup.push(newBroadcastData);
                    broadcast.update(broadcastGroupId, newBroadcastGroup);
                  });

                // 更新至公播盒
                await broadcastBox
                  .find({ query: { broadcastId: broadcastGroupId } })
                  .then((res) => {
                    if (res.data.length > 0) {
                      for (let i = 0; i < res.data.length; i++) {
                        const newRecord = {
                          broadcastId: broadcastGroupId,
                          broadcastBoxsId: [res.data[i]._id],
                        };

                        axios('/ezcon/api/enableBroadcast', {
                          method: 'POST',
                          headers: {
                            authorization: window.localStorage['feathers-jwt'],
                          },
                          data: newRecord,
                        })
                          .then(() => {
                            Message.success('資料更新成功並發佈至公播盒');
                          })
                          .catch((err) => {
                            console.log(err);
                            Message.error(err);
                          });
                      }
                    }
                  });
              }
            }
          });
        }}
        onCancel={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setCheckedStatus(false);
          setParsed64('');
          setAllows([]);
          setMessageStatus(false);
          setAnnouncementDialog(false);
          setFileList([]);
        }}
        onClose={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setCheckedStatus(false);
          setParsed64('');
          setAllows([]);
          setMessageStatus(false);
          setAnnouncementDialog(false);
          setFileList([]);
        }}
      >
        <Form>
          <h3>{`新增${props.data.name}事項`}</h3>
          {/* <Item label="公告單位">
          {userName}
          </Item> */}
          <Item label={`${props.data.name}日期`}>
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              disabledDate={disabledDate}
              value={announcementTime}
              onChange={(value) => {
                if (value) {
                  console.log({ value });
                  setAnnouncementTime(value);
                } else {
                  setAnnouncementTime(moment());
                }
              }}
            />
          </Item>
          <Item label="類別">
            <Select
              hasClear
              className={styles.options}
              placeholder="請選擇類別"
              dataSource={categoryDataArr}
              onChange={(value) => {
                setCategory(value);
              }}
            />
            {props.data.display === true && (
              <Checkbox
                className={styles.checkbox}
                label={`置頂(重要${props.data.name})`}
                onChange={(checked) => {
                  setCheckedStatus(checked);
                }}
              />
            )}
          </Item>
          <Item label="標題">
            <Input
              name="title"
              placeholder="請輸入標題"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setTitleText(value);
              }}
            />
          </Item>
          <Item label="內容">
            <Input.TextArea
              name="content"
              placeholder="請輸入內容"
              maxLength={500}
              rows={6}
              hasLimitHint
              aria-label="input max length 500"
              onChange={(value) => {
                setContentText(value);
              }}
            />
          </Item>
          <Item label="上傳照片">
            <Upload
              customRequest={async (options) => {
                const { onSuccess, onError, file } = options;
                if (file.size > 1024 * 1024 * 20) {
                  onError({ message: '上傳檔案不能超過20MB' });
                  return;
                }
                try {
                  const res = await uploadFiles(options.file);

                  onSuccess(res.data);
                  setFileList((prev) => [
                    ...prev,
                    {
                      path: res.data.showPath,
                      id: res.data._id,
                      name: file.name,
                    },
                  ]);
                } catch (err) {
                  onError(err, null);
                }
              }}
              onRemove={async (file) => {
                try {
                  const res = await deleteUploadFile(file);
                  console.log(res);
                  const newFileList = fileList.filter(
                    (item) => item.id !== res._id
                  );
                  setFileList(newFileList);
                } catch (err) {
                  console.error({ err });
                }
              }}
            >
              <Button>上傳</Button>
            </Upload>
          </Item>
          <Item label="是否發佈於公播">
            <Switch
              className={styles.messageSwitch}
              checkedChildren="發佈"
              unCheckedChildren="不發佈"
              onChange={(checked) => {
                setBroadcastStatus(checked);
                if (checked === false) setBroadcastGroupId('');
              }}
            />
          </Item>
          <Item
            label="選擇公播群組名稱："
            className={
              broadcastStatus === true
                ? styles.messageCheckbox
                : styles.messageCheckboxNone
            }
          >
            <Select onChange={(value) => setBroadcastGroupId(value)}>
              {broadcastData.map((item) => (
                <Select.Option value={item._id}>{item.title}</Select.Option>
              ))}
            </Select>
          </Item>

          {props.data.display === true && (
            <Item label="是否開啟推播">
              <Switch
                className={styles.messageSwitch}
                checkedChildren="開啟推播"
                unCheckedChildren="關掉推播"
                onChange={(checked) => {
                  console.log(checked);
                  if (checked === true) {
                    setMessageStatus(true);
                  } else {
                    setMessageStatus(false);
                    setAllows([]);
                  }
                }}
              />
            </Item>
          )}
          <Item
            label="選擇推播棟別:"
            help="此為棟別名稱"
            className={
              messageStatus === true
                ? styles.messageCheckbox
                : styles.messageCheckboxNone
            }
          >
            <Checkbox.Group
              className={styles.optionList}
              itemDirection="ver"
              dataSource={allowsCheckBox()}
              onChange={(value) => {
                residentAccountNumbers
                  .find({ query: { building: { $in: value } } })
                  .then((res) => {
                    setAllows(res.data.map((item) => item.householdNumber));
                  });
              }}
            />
          </Item>
        </Form>
      </Dialog>

      {/* 新增公告  檔案類型 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addNotImgDialog}
        onOk={() => {
          Swal.fire({
            title: `確定新增標題(${titleText})${props.data.name}?`,
            text: '請確認資料填寫完整!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire('成功!', `此${props.data.name}已新增`, 'success');
              const formData = new FormData();

              formData.append('createdTime', new Date().getTime());
              formData.append('updatedTime', new Date().getTime());
              // formData.append('order', announcementArr.length);
              formData.append('announcer', userName);
              formData.append('announcementTime', announcementTime.valueOf());
              formData.append('type', category);
              formData.append('title', titleText);
              formData.append('content', contentText);
              if (props.data.display === true) {
                formData.append('checkedStatus', checkedStatus);
              }

              formData.append('fileType', 'file');

              if (uploadOtherFile.current.files.length > 0) {
                otherFile.forEach((file) => formData.append('files', file));
              }
              if (props.data.display === true) {
                formData.append('allows', JSON.stringify(allows));
              }

              axios(`/uploads?type=${props.data.service}`, {
                method: 'POST',
                headers: { authorization: window.localStorage['feathers-jwt'] },
                data: formData,
              })
                .then((res) => {
                  console.log('==announcement create success:', res.data);
                  Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: '送出成功',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  serverDataUpdate();
                  // setParsed64('');
                  setOtherFile([]);
                  setAllows([]);
                  setMessageStatus(false);
                  setAddNotImgDialog(false);
                })
                .catch((error) => {
                  console.log('==announcement create fail:', error);
                });
            }
          });
        }}
        onCancel={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setCheckedStatus(false);
          // setParsed64('');
          setOtherFile([]);
          setAllows([]);
          setMessageStatus(false);
          setAddNotImgDialog(false);
        }}
        onClose={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setCheckedStatus(false);
          // setParsed64('');
          setOtherFile([]);
          setAllows([]);
          setMessageStatus(false);
          setAddNotImgDialog(false);
        }}
      >
        <Form>
          <h3>{`新增${props.data.name}事項`}</h3>
          {/* <Item label="公告單位">
          {userName}
          </Item> */}

          <Item label={`${props.data.name}日期`}>
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              value={announcementTime}
              disabledDate={disabledDate}
              onChange={(value) => {
                if (value) {
                  setAnnouncementTime(value);
                } else {
                  setAnnouncementTime(moment());
                }
              }}
            />
          </Item>

          <Item label="類別">
            <Select
              hasClear
              className={styles.options}
              placeholder="請選擇類別"
              dataSource={categoryDataArr}
              onChange={(value) => {
                //  console.log(value)
                setCategory(value);
              }}
            />
            {props.data.display === true && (
              <Checkbox
                className={styles.checkbox}
                label={`置頂(重要${props.data.name})`}
                onChange={(checked) => {
                  setCheckedStatus(checked);
                }}
              />
            )}
          </Item>
          <Item label="標題">
            <Input
              name="title"
              placeholder="請輸入標題"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setTitleText(value);
              }}
            />
          </Item>
          <Item label="內容">
            <Input.TextArea
              name="content"
              placeholder="請輸入內容"
              maxLength={500}
              rows={6}
              hasLimitHint
              aria-label="input max length 500"
              onChange={(value) => {
                setContentText(value);
              }}
            />
          </Item>
          <Item label="上傳檔案">
            <input
              accept=".xlsx,.docx,.pdf,image/png,image/jpeg,image/jpg"
              ref={uploadOtherFile}
              onChange={handleOtherFiles}
              type="file"
              id="file"
              name="files"
              multiple
            />
          </Item>
          <div className={styles.editFileBox}>
            {otherFile
              ? otherFile.map((list, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <p>{list.name}</p>
                      <button
                        type="button"
                        onClick={() => deleteFile(list.name)}
                        style={{ marginLeft: '10px' }}
                      >
                        刪除
                      </button>
                    </div>
                  );
                })
              : ''}
          </div>
          {props.data.display === true && (
            <Switch
              className={styles.messageSwitch}
              checkedChildren="開啟推播"
              unCheckedChildren="關掉推播"
              onChange={(checked) => {
                console.log(checked);
                if (checked === true) {
                  setMessageStatus(true);
                } else {
                  setMessageStatus(false);
                  setAllows([]);
                }
              }}
            />
          )}
          <Item
            label="選擇推播棟別:"
            help="此為棟別名稱"
            className={
              messageStatus === true
                ? styles.messageCheckbox
                : styles.messageCheckboxNone
            }
          >
            <Checkbox.Group
              className={styles.optionList}
              itemDirection="ver"
              dataSource={allowsCheckBox()}
              onChange={(value) => {
                residentAccountNumbers
                  .find({ query: { building: { $in: value } } })
                  .then((res) => {
                    setAllows(res.data.map((item) => item.householdNumber));
                  });
              }}
            />
          </Item>
        </Form>
      </Dialog>

      {/* 編輯公告 圖片類型 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editAnnouncementDialog}
        onOk={() => {
          Swal.fire({
            title: `確定修改標題(${titleText})${props.data.name}?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then(async (result) => {
            if (result.isConfirmed) {
              Swal.fire('成功!', `此${props.data.name}已編輯`, 'success');
              // const data = currentPosts[editAnnouncementIndex];
              // let patchUrl = `/uploads?type=${props.data.service}&id=${data._id}&createCompressImage=true`;

              // const formData = new FormData();

              // formData.append('updatedTime', new Date().getTime());
              // // formData.append('order', announcementArr.length);
              // formData.append('announcer', userName);
              // formData.append('announcementTime', announcementTime.valueOf());
              // formData.append('type', category);
              // formData.append('title', titleText);
              // formData.append('content', contentText);
              // if (props.data.display === true) {
              //   formData.append('checkedStatus', checkedStatus);
              // }

              // if (uploadFile.current.files.length > 0) {
              //   formData.append('files', uploadFile.current.files[0]);
              // }
              // if (!uploadFile.current.files.length) {
              //   patchUrl = `/uploads?type=${props.data.service}&id=${data._id}&img=keep`;
              // }
              // formData.append(
              //   'broadcastStatus',
              //   JSON.stringify(broadcastStatus)
              // );
              // if (broadcastStatus) {
              //   formData.append('broadcastGroupId', broadcastGroupId);
              // } else {
              //   formData.append('broadcastGroupId', '');
              // }

              // let showPath = '';

              // await axios(patchUrl, {
              //   method: 'PATCH',
              //   headers: { authorization: window.localStorage['feathers-jwt'] },
              //   data: formData,
              // })
              //   .then((response) => {
              //     console.log(
              //       '==announcement update success:',
              //       response.statusText
              //     );

              //     Swal.fire({
              //       position: 'center',
              //       icon: 'success',
              //       title: '編輯成功',
              //       showConfirmButton: false,
              //       timer: 1500,
              //     });
              //     showPath = response.data.showPath;
              //     serverDataUpdate();
              //     setTitleText('');
              //     setContentText('');
              //     setCategory('');
              //     setAnnouncementTime(moment());
              //     setCheckedStatus(false);
              //     setFile([]);
              //     setParsed64('');
              //     setEditAnnouncementDialog(false);
              //   })
              //   .catch((error) => {
              //     console.log('==announcement update fail:', error);
              //   });
              const data = currentPosts[editAnnouncementIndex];
              let announcementNewArr = '';
              const newObject = {
                createdTime: moment().valueOf(),
                updatedTime: moment().valueOf(),
                order: announcementArr.length,
                announcer: userName,
                announcementTime: announcementTime.valueOf(),
                type: category,
                title: titleText,
                titleText: contentText,
                fileType: 'img',
                allows,
                files: fileList,
                broadcastStatus,
                broadcastGroupId,
                checkedStatus,
              };
              await announcement
                .patch(data._id, newObject)
                .then((res) => {
                  console.log(res);
                  serverDataUpdate();
                  setParsed64('');
                  setAllows([]);
                  setMessageStatus(false);
                  setEditAnnouncementDialog(false);
                  setFileList([]);
                  setCheckedStatus(false);
                  announcementNewArr = res;
                })
                .catch((error) => {
                  console.log('==announcement create fail:', error);
                });

              // 新增至公播清單中

              if (broadcastStatus && broadcastGroupId) {
                let newBroadcastData = '';
                const newChildren = [];
                for (let i = 0; i < announcementNewArr.files.length; i++) {
                  newChildren.push({
                    typeContent: 'image',
                    typeFormat: announcementNewArr.files[i].path,
                    textSize: 'originalSize',
                    textTags: '',
                    textColor: '',
                    textLevel: 'center',
                    textVertical: 'center',
                    unit: 's',
                    seconds: 10,
                  });
                }
                const newBroadcast = {
                  title: titleText,
                  backgroundMusic: null,
                  userName,
                  template: 'one',
                  announcementId: announcementNewArr._id,
                  content: [
                    {
                      carousel: true,
                      color: '#FFFFFF',
                      size: 100,
                      children: [...newChildren],
                    },
                  ],
                };
                await broadcast.create(newBroadcast).then((res) => {
                  newBroadcastData = res;
                  Message.success('新增至公播清單中');
                  console.log(res);
                });

                // 更新公播群組
                await broadcast
                  .find({ query: { _id: broadcastGroupId } })
                  .then((res) => {
                    const newBroadcastGroup = res.data[0];
                    newBroadcastGroup.broadcastGroupId.push(
                      newBroadcastData._id
                    );
                    newBroadcastGroup.broadcastGroup.push(newBroadcastData);
                    broadcast.update(broadcastGroupId, newBroadcastGroup);
                  });

                // 更新至公播盒
                await broadcastBox
                  .find({ query: { broadcastGroupId } })
                  .then((res) => {
                    if (res.data.length > 0) {
                      for (let i = 0; i < res.data.length; i++) {
                        const newRecord = {
                          broadcastId: broadcastGroupId,
                          broadcastBoxsId: [res.data[i]._id],
                        };

                        axios('/ezcon/api/enableBroadcast', {
                          method: 'POST',
                          headers: {
                            authorization: window.localStorage['feathers-jwt'],
                          },
                          data: newRecord,
                        })
                          .then(() => {
                            Message.success('資料更新成功並發佈至公播盒');
                          })
                          .catch((err) => {
                            console.log(err);
                            Message.error(err);
                          });
                      }
                    }
                  });
              } else if (
                data.broadcastGroupId !== '' &&
                broadcastStatus === false
              ) {
                let newBroadcastId = '';
                await broadcast
                  .find({ query: { announcementId: data._id } })
                  .then((res) => {
                    console.log(res);
                    newBroadcastId = res.data[0]._id;
                  });
                await broadcast
                  .find({ query: { _id: broadcastGroupId } })
                  .then((res) => {
                    let newBroadcastGroup = res.data[0];
                    const filterBroadcastGroup = newBroadcastGroup.broadcastGroup.filter(
                      (item) => {
                        return item._id !== newBroadcastId;
                      }
                    );
                    const filterBroadcastGroupId = newBroadcastGroup.broadcastGroupId.filter(
                      (item) => {
                        return item !== newBroadcastId;
                      }
                    );
                    newBroadcastGroup = {
                      ...newBroadcastGroup,
                      broadcastGroupId: filterBroadcastGroupId,
                      broadcastGroup: filterBroadcastGroup,
                    };
                    broadcast.update(broadcastGroupId, newBroadcastGroup);
                  });
                await broadcast.remove(newBroadcastId);
              }

              // 更新至公播盒
              broadcastBox
                .find({ query: { broadcastId: broadcastGroupId } })
                .then((res) => {
                  if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                      const newRecord = {
                        broadcastId: broadcastGroupId,
                        broadcastBoxsId: [res.data[i]._id],
                      };

                      axios('/ezcon/api/enableBroadcast', {
                        method: 'POST',
                        headers: {
                          authorization: window.localStorage['feathers-jwt'],
                        },
                        data: newRecord,
                      })
                        .then(() => {
                          Message.success('資料更新成功並發佈至公播盒');
                        })
                        .catch((err) => {
                          console.log(err);
                          Message.error(err);
                        });
                    }
                  }
                });
            }
          });
        }}
        onCancel={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setAnnouncementTime(moment());
          setCheckedStatus(false);
          setFile([]);
          setParsed64('');
          setEditAnnouncementDialog(false);
          setFileList([]);
        }}
        onClose={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setAnnouncementTime(moment());
          setCheckedStatus(false);
          setFile([]);
          setParsed64('');
          setEditAnnouncementDialog(false);
          setFileList([]);
        }}
      >
        <Form>
          <h3>{`編輯${props.data.name}事項`}</h3>
          <Item label={`${props.data.name}日期`}>
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              disabledDate={disabledDate}
              value={announcementTime}
              onChange={(value) => {
                if (value) {
                  setAnnouncementTime(value);
                } else {
                  setAnnouncementTime(moment());
                }
              }}
            />
          </Item>

          <Item label="類別">
            <Select
              hasClear
              className={styles.options}
              dataSource={categoryDataArr}
              value={category}
              onChange={(value) => {
                setCategory(value);
              }}
            />
            {props.data.display === true && (
              <Checkbox
                defaultChecked={checkedStatus === 'true'}
                className={styles.checkbox}
                label={`置頂(重要${props.data.name})`}
                onChange={(checked) => {
                  setCheckedStatus(checked);
                }}
              />
            )}
          </Item>
          <Item label="標題">
            <Input
              value={titleText}
              name="title"
              placeholder="請輸入標題"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setTitleText(value);
              }}
            />
          </Item>
          <Item label="內容">
            <Input.TextArea
              value={contentText}
              name="content"
              placeholder="請輸入內容"
              maxLength={500}
              rows={6}
              hasLimitHint
              aria-label="input max length 500"
              onChange={(value) => {
                setContentText(value);
              }}
            />
          </Item>
          <Item label="上傳照片">
            {/* <input
              accept="image/png,image/jpeg,image/jpg"
              ref={uploadFile}
              onChange={handleFiles}
              type="file"
              id="file"
              name="files"
              // multiple
            /> */}
            <Upload
              fileList={fileList}
              customRequest={async (options) => {
                const { onSuccess, onError, file } = options;
                if (file.size > 1024 * 1024 * 20) {
                  onError({ message: '上傳檔案不能超過20MB' });
                  return;
                }
                try {
                  const res = await uploadFiles(options.file);

                  onSuccess(res.data);
                  setFileList((prev) => [
                    ...prev,
                    {
                      path: res.data.showPath,
                      id: res.data._id,
                      name: file.name,
                    },
                  ]);
                } catch (err) {
                  onError(err, null);
                }
              }}
              onRemove={async (file) => {
                try {
                  const res = await deleteUploadFile(file);
                  console.log(res);
                  const newFileList = fileList.filter(
                    (item) => item.id !== res._id
                  );
                  setFileList(newFileList);
                } catch (err) {
                  console.error({ err });
                }
              }}
            >
              <Button>上傳</Button>
            </Upload>
          </Item>

          <Item label="是否發佈於公播">
            <Switch
              className={styles.messageSwitch}
              checkedChildren="發佈"
              unCheckedChildren="不發佈"
              checked={broadcastStatus}
              onChange={(checked) => {
                setBroadcastStatus(checked);
              }}
            />
          </Item>
          <Item
            label="選擇公播群組名稱："
            className={
              broadcastStatus === true
                ? styles.messageCheckbox
                : styles.messageCheckboxNone
            }
          >
            <Select
              defaultValue={broadcastGroupId}
              onChange={(value) => setBroadcastGroupId(value)}
            >
              {broadcastData.map((item, index) => (
                <Select.Option value={item._id} key={index}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Item>
          {/* <img
            style={{ width: '50px', height: '50px' }}
            src={`${parsed64.length > 0 ? parsed64 : file[0]}`}
            alt="圖片"
          /> */}
        </Form>
      </Dialog>

      {/* 編輯公告 檔案類型 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editNotImgDialog}
        onOk={() => {
          Swal.fire({
            title: `確定修改標題(${titleText})${props.data.name}?`,
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire('成功!', `此${props.data.name}已編輯`, 'success');
              const data = currentPosts[editAnnouncementIndex];
              let patchUrl = `/uploads?type=${props.data.service}&id=${data._id}`;

              const formData = new FormData();

              formData.append('updatedTime', new Date().getTime());
              // formData.append('order', announcementArr.length);
              formData.append('announcer', userName);
              formData.append('announcementTime', announcementTime.valueOf());
              formData.append('type', category);
              formData.append('title', titleText);
              formData.append('content', contentText);
              if (props.data.display === true) {
                formData.append('checkedStatus', checkedStatus);
              }

              if (uploadOtherFile.current.files.length > 0) {
                otherFile.forEach((file) => formData.append('files', file));
              }
              if (!uploadOtherFile.current.files.length) {
                patchUrl = `/uploads?type=${props.data.service}&id=${data._id}&img=keep`;
              }

              axios(patchUrl, {
                method: 'PATCH',
                headers: { authorization: window.localStorage['feathers-jwt'] },
                data: formData,
              })
                .then((response) => {
                  console.log(
                    '==announcement update success:',
                    response.statusText
                  );

                  Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: '編輯成功',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  serverDataUpdate();
                  setTitleText('');
                  setContentText('');
                  setCategory('');
                  setAnnouncementTime(moment());
                  setCheckedStatus(false);
                  setFile([]);
                  setOtherFile([]);
                  // setParsed64('');
                  setKeepFileStatus(false);
                  setEditNotImgDialog(false);
                })
                .catch((error) => {
                  console.log('==announcement update fail:', error);
                });
            }
          });
        }}
        onCancel={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setAnnouncementTime(moment());
          setCheckedStatus(false);
          setFile([]);
          setOtherFile([]);
          // setParsed64('');
          setKeepFileStatus(false);
          setEditNotImgDialog(false);
        }}
        onClose={() => {
          setTitleText('');
          setContentText('');
          setCategory('');
          setAnnouncementTime(moment());
          setCheckedStatus(false);
          setFile([]);
          setOtherFile([]);
          // setParsed64('');
          setKeepFileStatus(false);
          setEditNotImgDialog(false);
        }}
      >
        <Form>
          <h3>{`編輯${props.data.name}事項`}</h3>
          <Item label={`${props.data.name}日期`}>
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              disabledDate={disabledDate}
              value={announcementTime}
              onChange={(value) => {
                if (value) {
                  setAnnouncementTime(value);
                } else {
                  setAnnouncementTime(moment());
                }
              }}
            />
          </Item>

          <Item label="類別">
            <Select
              hasClear
              className={styles.options}
              dataSource={categoryDataArr}
              value={category}
              onChange={(value) => {
                //  console.log(value)
                setCategory(value);
              }}
            />
            {props.data.display === true && (
              <Checkbox
                defaultChecked={checkedStatus === 'true'}
                className={styles.checkbox}
                label={`置頂(重要${props.data.name})`}
                onChange={(checked) => {
                  setCheckedStatus(checked);
                }}
              />
            )}
          </Item>
          <Item label="標題">
            <Input
              value={titleText}
              name="title"
              placeholder="請輸入標題"
              maxLength={25}
              hasLimitHint
              aria-label="input max length 25"
              onChange={(value) => {
                setTitleText(value);
              }}
            />
          </Item>
          <Item label="內容">
            <Input.TextArea
              value={contentText}
              name="content"
              placeholder="請輸入內容"
              maxLength={500}
              rows={6}
              hasLimitHint
              aria-label="input max length 500"
              onChange={(value) => {
                setContentText(value);
              }}
            />
          </Item>
          <Checkbox
            onChange={(checked) => {
              if (checked === true) {
                setKeepFileStatus(true);
              } else {
                setKeepFileStatus(false);
              }
            }}
          >
            是否重新上傳檔案
          </Checkbox>
          <Item
            style={
              keepFileStatus === true
                ? { display: 'block' }
                : { display: 'none' }
            }
            label="上傳檔案"
            help="編輯僅能重新上傳資料"
          >
            <input
              accept=".xlsx,.docx,.pdf,image/png,image/jpeg,image/jpg"
              ref={uploadOtherFile}
              onChange={handleOtherFiles}
              type="file"
              id="file"
              name="files"
              multiple
            />
            <div className={styles.editFileBox}>
              {otherFile
                ? otherFile.map((list, index) => {
                    return (
                      <div
                        key={index}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <p>{list.name}</p>
                        <button
                          type="button"
                          onClick={() => deleteFile(list.name)}
                          style={{ marginLeft: '10px' }}
                        >
                          刪除
                        </button>
                      </div>
                    );
                  })
                : ''}
            </div>
          </Item>
        </Form>
      </Dialog>

      {/* 查看 */}
      <Modal
        okText
        cancelText="關閉"
        mask={false}
        className={styles.modal}
        // width={"100vw"}
        style={{ top: 0 }}
        visible={previewSingleDialog}
        onOk={() => {
          setPreviewSingleDialog(false);
          setFileViewerStatus(false);
          setFileViewerPath('');
          setFileViewerType('');
        }}
        onCancel={() => {
          setPreviewSingleDialog(false);
          setFileViewerStatus(false);
          setFileViewerPath('');
          setFileViewerType('');
        }}
      >
        {fileType === 'img' && (
          <div className={styles.previewContainer}>
            <div className={styles.previewFlagBox}>
              <div className={styles.previewFlag}>
                <div
                  className={
                    category ? previewTypeStyles(category) : styles.typeNone
                  }
                >
                  {category}
                </div>
                <div
                  className={
                    checkedStatus === 'true'
                      ? styles.previewFlagBlock
                      : styles.previewFlagNone
                  }
                >
                  {checkedStatus === 'true' ? '置頂' : ''}
                </div>
              </div>
              <div className={styles.previewDate}>
                {moment(announcementTime).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            </div>
            <div className={styles.previewTitleBox}>
              <div className={styles.previewTitle}>標題</div>
              <div className={styles.previewTitleText}>{titleText}</div>
            </div>
            <div className={styles.previewContentBox}>
              <div className={styles.previewContent}>內容</div>
              <div className={styles.previewContentText}>{contentText}</div>
            </div>
            <div className={styles.previewImgBox}>
              <div className={styles.previewImgText}>檔案 </div>
              {file[0] === '' ? (
                <div className={styles.filesNone}>無</div>
              ) : (
                <>
                  <div className={styles.previewImg}>
                    <Image width="100%" height="100%" src={file} alt="檔案" />
                  </div>
                  <a
                    className={styles.download}
                    download={file}
                    target="_blank"
                    rel="noreferrer"
                    href={file}
                  >
                    {file === '' ? '' : '下載'}
                  </a>
                  {/* <Button
                      type="primary"
                      className={styles.download}
                      disabled={fetching}
                      onClick={() => {
                        download(file, file)
                        Message.success("檔案存放到下載目錄")
                      }}
                    >
                      {file[0] === "" ? "" : "下載"}
                    </Button> */}
                </>
              )}
            </div>
          </div>
        )}
        {fileType !== 'img' && file.length > 1 && (
          <div className={styles.previewFileContainer}>
            <div className={styles.previewMultipleBox}>
              {file.map((list, index) => {
                return (
                  <div key={index} className={styles.previewBtnBox}>
                    <Button
                      className={styles.previewBtn}
                      type="primary"
                      key={index}
                      onClick={() => {
                        setFileViewerKey(index + Math.random());
                        setFileViewerStatus(true);
                        setFileViewerPath(list);
                        setFileViewerType(
                          list.split('.')[list.split('.').length - 1]
                        );
                      }}
                    >
                      附件{index + 1}點擊顯示
                    </Button>
                    <a
                      className={styles.download}
                      download={list}
                      target="_blank"
                      rel="noreferrer"
                      href={list}
                    >
                      {list === '' ? '' : '下載'}
                    </a>
                    {/* <Button
                          type="primary"
                          className={styles.download}
                          disabled={fetching}
                          onClick={() => {
                            download(list, list)
                            Message.success("檔案存放到下載目錄")
                          }}
                        >
                          {list === "" ? "" : "下載"}
                        </Button> */}
                  </div>
                );
              })}
            </div>
            {fileViewerType.split('.')[fileViewerType.split('.').length - 1] ===
            'pdf' ? (
              <React.Suspense fallback={<div>Loading...</div>}>
                <div key={fileViewerKey} className={styles.documentBlock}>
                  {/* REFER: */}
                  <Document
                    file={fileViewerPath}
                    options={{ workerSrc: '/pdf.worker.js' }}
                    onLoadSuccess={onDocumentLoadSuccess}
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                  </Document>
                </div>
              </React.Suspense>
            ) : (
              <React.Suspense fallback={<div>Loading...</div>}>
                <div key={fileViewerKey} className={styles.fileViewerBlock}>
                  <FileViewer
                    filePath={fileViewerPath}
                    fileType={fileViewerType}
                    onError={onError}
                  />
                </div>
              </React.Suspense>
            )}
          </div>
        )}
        {fileType !== 'img' &&
          !(file.length > 1) &&
          file.map((list, index) => {
            return (
              <div className={styles.previewFileContainer}>
                {list === '' ? (
                  <h1>{list === '' ? '沒有檔案' : ''}</h1>
                ) : (
                  <a
                    className={styles.download}
                    download={list}
                    target="_blank"
                    rel="noreferrer"
                    href={list}
                  >
                    {list[0] === '' ? '' : '下載'}
                  </a>
                )}
                {/* <Button
                        type="primary"
                        className={styles.download}
                        disabled={fetching}
                        onClick={() => {
                          download(list, list)
                          Message.success("檔案存放到下載目錄")
                        }}
                      >
                        {list === "" ? "" : "下載"}
                      </Button> */}

                {list.split('.')[list.split('.').length - 1] === 'pdf' ? (
                  <React.Suspense fallback={<div>Loading...</div>}>
                    <div key={index} className={styles.documentBlock}>
                      <Document
                        file={list}
                        options={{ workerSrc: '/pdf.worker.js' }}
                        onLoadSuccess={onDocumentLoadSuccess}
                      >
                        {Array.from(new Array(numPages), (el, index) => (
                          <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                          />
                        ))}
                      </Document>
                    </div>
                  </React.Suspense>
                ) : (
                  <React.Suspense fallback={<div>Loading...</div>}>
                    <div key={index} className={styles.fileViewerBlock}>
                      <FileViewer
                        filePath={list}
                        fileType={list.split('.')[list.split('.').length - 1]}
                        onError={onError}
                      />
                    </div>
                  </React.Suspense>
                )}
              </div>
            );
          })}
      </Modal>

      <div className={styles.container}>
        <div className={styles.btnBox}>
          <Button
            className={styles.btnItem1}
            onClick={() => {
              setAnnouncementDialog(true);
            }}
          >
            {`新增圖片類型${props.data.name}`}
          </Button>

          <Button
            className={styles.btnItem}
            onClick={() => {
              setAddNotImgDialog(true);
            }}
          >
            {`新增檔案類型${props.data.name}`}
          </Button>
          <Button
            type="secondary"
            className={styles.btnItem}
            onClick={() => {
              setCategoryDialog(true);
            }}
          >
            {`${props.data.name}類別`}
          </Button>

          <Button
            className={styles.btnItem}
            type="primary"
            onClick={() => {
              setSearchDialog(true);
            }}
          >
            {`查詢${props.data.name}`}
          </Button>
          <Button
            className={styles.btnItem}
            type="primary"
            onClick={() => {
              serverDataUpdate();
            }}
          >
            重置搜尋
          </Button>
        </div>
        {/* <ReactDragListView onDragEnd={onDragEnd} > */}
        <Card free>
          <Card.Content>
            {/* <p>可拖曳表格欄位變換順序</p> */}
            <Table dataSource={currentPosts} onSort={onTableSort}>
              {/* <Table.Column sortable title="順序" dataIndex="order" width={100} /> */}
              <Table.Column
                lock="left"
                sortable
                title="發布時間"
                dataIndex="createdTime"
                width={200}
                cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
              />
              <Table.Column
                sortable
                title={`${props.data.name}單位`}
                dataIndex="announcer"
                width={100}
              />
              <Table.Column
                sortable
                title={`${props.data.name}時間`}
                dataIndex="announcementTime"
                cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
                width={200}
              />
              <Table.Column
                sortable
                title="類別"
                dataIndex="type"
                width={100}
              />
              <Table.Column
                sortable
                title="標題"
                dataIndex="title"
                width={100}
              />
              <Table.Column
                sortable
                title="內容"
                dataIndex="content"
                width={100}
              />
              {props.data.display === true && (
                <Table.Column
                  sortable
                  title="置頂"
                  dataIndex="checkedStatus"
                  width={100}
                  cell={(_value, index) => {
                    return (
                      <>
                        {currentPosts[index].checkedStatus === 'true'
                          ? '是'
                          : '否'}
                      </>
                    );
                  }}
                />
              )}
              {/* <Table.Column title="檔案" width={100} cell={(record, index) => {
                                return (<>
                  <img className={styles.imageUrl} alt="No Data" src={announcementArr[index].files} />
                </>)
              }
              } /> */}

              <Table.Column
                title="檔案"
                width={200}
                cell={(_value, _index, record) => {
                  if (record.files) {
                    return (
                      <>
                        {record.files.map((list, index) => {
                          return (
                            <a
                              style={
                                list === ''
                                  ? { display: 'none' }
                                  : { display: 'block' }
                              }
                              target="_blank"
                              rel="noreferrer"
                              key={index}
                              href={list}
                            >
                              <span
                                role="img"
                                aria-label="spin"
                                aria-labelledby=""
                              >
                                📎
                              </span>
                              {` 附件${index + 1}`}
                            </a>
                          );
                        })}
                      </>
                    );
                  }
                }}
              />
              <Table.Column
                title="操作"
                width={200}
                lock="right"
                cell={(_value, index, record) => {
                  return (
                    <div className={styles.btn}>
                      <Button
                        type="primary"
                        onClick={() => {
                          // alert(record.files)
                          setTitleText(record.title);
                          setContentText(record.content);
                          setCategory(record.type);
                          setAnnouncementTime(moment(record.announcementTime));
                          setFile(record.files);
                          if (props.data.display === true) {
                            setCheckedStatus(record.checkedStatus);
                          }
                          setFileType(record.fileType);
                          setPreviewSingleDialog(true);
                          // setEditAnnouncementIndex(index);

                          // if (currentPosts[index].fileType === 'img') {
                          //   setEditAnnouncementDialog(true);
                          // } else {
                          //   setEditNotImgDialog(true);
                          // }
                        }}
                      >
                        查看
                      </Button>
                      <Button
                        type="normal"
                        onClick={() => {
                          setTitleText(record.title);
                          setContentText(record.content);
                          setCategory(record.type);
                          setAnnouncementTime(moment(record.announcementTime));
                          setFile(record.files);
                          if (props.data.display === true) {
                            setCheckedStatus(record.checkedStatus);
                          }

                          setEditAnnouncementIndex(index);

                          if (record.fileType === 'img') {
                            setEditAnnouncementDialog(true);
                          } else {
                            setEditNotImgDialog(true);
                          }
                          setBroadcastStatus(record.broadcastStatus);
                          setBroadcastGroupId(record.broadcastGroupId);
                          setFileList(record.files);
                        }}
                      >
                        編輯
                      </Button>

                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          const item = record;
                          Swal.fire({
                            title: `確定刪除標題(${record.title})${props.data.name}?`,
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire(
                                '刪除!',
                                `此${props.data.name}已刪除`,
                                'success'
                              );
                              funRemove(item._id).then(() => {
                                // removeItem();
                                const prePages =
                                  currentPage - 1 >= 0 ? currentPage - 1 : 0;
                                if (
                                  announcementArr.length - 1 <=
                                  prePages * postsPerPage
                                ) {
                                  setCurrentPage(
                                    currentPage - 1 < 1 ? 1 : currentPage - 1
                                  );
                                }
                                serverDataUpdate();
                              });
                            }
                          });
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              />
            </Table>

            <Pagination
              className={styles.pagination}
              total={announcementArr.length}
              pageSize={postsPerPage}
              totalRender={(total) => `Total: ${total}`}
              onChange={(pageNumber) => {
                setCurrentPage(pageNumber);
              }}
            />
          </Card.Content>
        </Card>
        {/* </ReactDragListView> */}
      </div>
    </>
  );
};

export default GlobalTempalate;
